var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.025,
    height: 16.025,
    viewBox: "0 0 16.025 16.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    transform: "translate(8.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M280.883,0H278.5A2.507,2.507,0,0,0,276,2.5V4.883a2.507,2.507,0,0,0,2.5,2.5h2.379a2.507,2.507,0,0,0,2.5-2.5V2.5A2.507,2.507,0,0,0,280.883,0Zm1.252,4.883a1.253,1.253,0,0,1-1.252,1.252H278.5a1.253,1.253,0,0,1-1.252-1.252V2.5A1.253,1.253,0,0,1,278.5,1.252h2.379A1.253,1.253,0,0,1,282.134,2.5Z",
    transform: "translate(-276)",
    fill: "#94c0d4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M4.883,0H2.5A2.507,2.507,0,0,0,0,2.5V4.883a2.507,2.507,0,0,0,2.5,2.5H4.883a2.507,2.507,0,0,0,2.5-2.5V2.5A2.507,2.507,0,0,0,4.883,0ZM6.135,4.883A1.253,1.253,0,0,1,4.883,6.135H2.5A1.253,1.253,0,0,1,1.252,4.883V2.5A1.253,1.253,0,0,1,2.5,1.252H4.883A1.253,1.253,0,0,1,6.135,2.5Z",
    fill: "#94c0d4"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305",
    transform: "translate(0 8.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M4.883,276H2.5A2.507,2.507,0,0,0,0,278.5v2.379a2.507,2.507,0,0,0,2.5,2.5H4.883a2.507,2.507,0,0,0,2.5-2.5V278.5A2.507,2.507,0,0,0,4.883,276Zm1.252,4.883a1.253,1.253,0,0,1-1.252,1.252H2.5a1.253,1.253,0,0,1-1.252-1.252V278.5A1.253,1.253,0,0,1,2.5,277.252H4.883A1.253,1.253,0,0,1,6.135,278.5Z",
    transform: "translate(0 -276)",
    fill: "#94c0d4"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307",
    transform: "translate(8.638 8.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M282.76,280.257a.626.626,0,0,0-.626.626,1.253,1.253,0,0,1-1.252,1.252H278.5a1.253,1.253,0,0,1-1.252-1.252V278.5a1.253,1.253,0,0,1,1.252-1.252h2.379a1.253,1.253,0,0,1,1.148.751.626.626,0,0,0,1.147-.5,2.5,2.5,0,0,0-2.295-1.5H278.5a2.507,2.507,0,0,0-2.5,2.5v2.379a2.507,2.507,0,0,0,2.5,2.5h2.379a2.507,2.507,0,0,0,2.5-2.5A.626.626,0,0,0,282.76,280.257Z",
    transform: "translate(-276 -276)",
    fill: "#94c0d4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.dee575f54e4e836f9d4b48ee2a07c0fb.svg";
export { ForwardRef as ReactComponent };